import React, { useEffect } from 'react'
import history from '../../../route/history'
import { regisActions, certificateActions } from '../../../store/actions'
import { connect } from 'react-redux'
import * as common from '../../../assets/js/common.js'

const RegisSuccess = (props) => {
  useEffect(() => {
    if (common.getDeviceType() === 'MobileApp') {
      window.M.data.removeStorage('memberId')
    }
    props.registComplete()
    props.setInitialState()
  }, [])

  return (
    <div id="contents">
      <div className="content-header type2">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>회원가입</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <em>회원가입</em>
        </div>
      </div>
      <div className="join-wrap">
        <div className="guide-box">
          <ul className="ulist1">
            <li>KTNET 사이트 가입을 위한 약관동의 절차입니다.</li>
            <li>회원가입에 입력한 정보는 암호화되어 안전하게 보관되어 집니다.</li>
            <li>약관을 동의하지 않을 경우 회원 가입에 제한이 있을 수 있습니다.</li>
          </ul>
          <p className="emphasize">※ 전자무역문서지갑 회원은 만 14세 이상만 가입할 수 있습니다.</p>
        </div>
        <ul className="steps mt40">
          <li>
            <span className="num">1</span>약관동의
          </li>
          <li>
            <span className="num">2</span>사업자/담당자정보
          </li>
          <li className="on">
            <span className="num">3</span>가입완료
          </li>
        </ul>
        <div className="join-end">
          <i />
          <p className="txt1">
            전자문서지갑 회원가입이
            <br /> 완료되었습니다!
          </p>
        </div>
        <div className="btn-block center">
          <a className="btn-primary xl cursor" onClick={() => history.replace('/loginIntro')}>
            로그인 페이지로 이동
          </a>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {
  registComplete: regisActions.registComplete,
  setInitialState: certificateActions.setInitialState,
}

export default connect(mapStateToProps, actionCreators)(RegisSuccess)
